import { render, staticRenderFns } from "./SubOrderDetail.vue?vue&type=template&id=6add19d0&scoped=true"
import script from "./SubOrderDetail.vue?vue&type=script&lang=js"
export * from "./SubOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SubOrderDetail.vue?vue&type=style&index=0&id=6add19d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add19d0",
  null
  
)

export default component.exports